import {
  ClearwaterTransaction,
  ExternalDataSourceType,
  UpdatedCwanTransaction,
} from '@helios/common-api'

export interface GetTransactionsResponse {
  data?: ClearwaterTransaction[]
  gridLoadStatus?: GridLoadStatus
}

export interface GridLoadStatus {
  specialColumnStatuses: { [colName: string]: string }
}

export enum ActionType {
  adjustBy = 'adjustBy',
  clear = 'clear',
  delete = 'delete',
  clearAndSetPost = 'clearAndSetPost',
  deleteAndIgnore = 'deleteAndIgnore',
  match = 'match',
  matchUsingExternal = 'matchUsingExternal',
  unclear = 'unclear',
  unmatch = 'unmatch',
  manyToManyMatch = 'manyToManyMatch',
  moveTransaction = 'moveTransaction',
}

export type MatchActionType =
  | ActionType.match
  | ActionType.matchUsingExternal
  | ActionType.unmatch
  | ActionType.manyToManyMatch

export interface TransactionActionRequest {
  actionType: ActionType
  cwTranRowIds: string[]
  extTranRowIds: string[]
  extDataSourceType?: ExternalDataSourceType // Used for Unmatch
  updatedCwanTransaction?: UpdatedCwanTransaction // Used for match-user-external-data
  destinationAccountId?: number //Used for Move to Different Sleeve
}

/**
 * Constructor for TransactionActionRequest objects
 */
export function createTransactionAction(
  actionType: ActionType,
  cwTranRowIds: string[] = [],
  extTranRowIds: string[] = [],
  extDataSourceType?: ExternalDataSourceType,
  updatedCwanTransaction?: UpdatedCwanTransaction,
  destinationAccountId?: number,
): TransactionActionRequest {
  return {
    actionType,
    cwTranRowIds,
    extTranRowIds,
    extDataSourceType,
    updatedCwanTransaction,
    destinationAccountId,
  }
}

export type TransactionsActionResponse = string[] | TransactionValidation

export interface TransactionValidation {
  validationId: string
  message: string
}
